import cn from 'clsx'

import { ProjectTile } from 'shared-components'

import s from './Related.module.sass'

function Related({ relatedProjects }: any) {
    if (!relatedProjects) return null

    return (
        <section className={s.Related}>
            <div className={cn(s.Cont, 'container')}>
                <h3>Explore similar projects</h3>
                <div className={s.Projects}>
                    {relatedProjects?.map((project: any, index: number) => {
                        return <ProjectTile project={project} key={index} />
                    })}
                </div>
            </div>
        </section>
    )
}

export default Related
